const fileNameRegex = /^[A-Za-z0-9._ -]+\.[A-Za-z0-9]{3,4}/;
const fileNameValidator = /^[A-Za-z0-9._ -]/;
const extensionValidator = /[A-Za-z0-9]/;

export const acceptableFileTypesArray = [
  'image/tiff',
  'image/tif',
  'image/jpeg',
  'image/png',
  'application/pdf',
];

export const convertToMB = (fileSizeInBytes, precision) => {
  return (fileSizeInBytes / (1024*1024)).toFixed(precision);
};
export const validateFile = (file) => {
  if(file) {
    const fileSize = file && file.size;
    const fileType = file && file.type;
    const fileName = file && file.name;

    const byteToMB = convertToMB(fileSize, 2);

    if(fileType) {
      if (!acceptableFileTypesArray.includes(fileType)) {
        alert('File Type not supported');
        return false;
      }
    }

    if(fileName) {
      const isValidName = validateFileName(fileName);
      if(!isValidName) {
        return false;
      }
    }

    if(fileSize) {
      if(byteToMB > 5) {
        alert('File exceeds maximum size');
        return false;
      }
    }
    return true;
  }
  return false;
};

const validateFileName = fileName => {
  const extension = fileName.split('.').pop();
  const name = fileName.split('.' + extension)[0];
  let invalidNameChars = [];
  let invalidExtensionChars = [];
  for(const i of name) {
    if(!fileNameValidator.test(i)) {
      invalidNameChars.push(i);
    }
  }
  for(const x of extension) {
    if(!extensionValidator.test(x)) {
      invalidExtensionChars.push(x);
    }
  }
  if(invalidNameChars.length) {
    alert('File name not supported. Invalid characters: ' + invalidNameChars.join(' '));
    return false;
  } else if(invalidExtensionChars.length) {
    alert('File extension not supported. Invalid characters: ' + invalidExtensionChars.join(' '));
    return false;
  } else if(extension.length > 4 || extension.length < 2) {
    alert('Invalid File Extension.')
    return false;
  } else if(!fileNameRegex.test(fileName)) {
    alert('File name not supported');
    return false;
  }
  return true;
}